/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  configure-apu-actions.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	     : Sep 25, 2019
 *
 * @Version      : Version 1.0
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 04, 2019
 * Description  : Updated code as per ASDS-1470
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 11, 2019
 * Description  : Updated code as per ASDS-1471
 *
 * By           : Sandeepraja (E807238  )
 * On           : Oct 15, 2019
 * Description  : ASDS-1551:  Modal screen Validations (MSA & Non MSA)
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 17, 2019
 * Description  : Updated code as per ASDS-1583
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 18, 2019
 * Description   : ASDS-1551: Validations in 3 Pop-Ups (MSA & Non MSA)
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Oct 22, 2019
 * Description   : ASDS-115: Add to Cart for APU - ASDS-115
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 30, 2019
 * Description  : Updated code as per ASDS-673
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1673: Add To Cart Conformation UI & Integration
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 1st, 2019
 * Description   : updated the code for ASDS-586
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 4th, 2019
 * Description   : updated the code for ASDS-407
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By           : H224423
 * On           : Nov 28, 2019
 * Description  : ASDS-1474 Accept product terms changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - loader/message while loading contract numbers in APU MSA flow
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 05, 2019
 * Description   : ASDS-2018
 *
 * By            : H224423
 * On            : 12 Dec, 2019
 * Description   : Terms Checkbox default checked issue fix.
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description    : ASDS-584
 *
 * By            : Deepthi Bachu - E844276
 * On            : 06 Feb, 2020
 * Description   : ASDS-1957 - APU - Add To Cart - Block Adding Serial Number if already in Cart
 *
 * By            : Deepthi Bachu - E844276
 * On            : 06 Feb, 2020
 * Description   : ASDS-1957 - SIT Observation
 *
 * By            : H224423
 * On            : 11 Feb, 2019
 * Description   : ASDS-2270 - Addressed APU Add to cart issue fixes.
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : H224423
 * On            : Feb 28, 2019
 * Description   : Changes to display delete msa warning popup when user clicks on change account.
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Contracts and sub-products API error handling.
 *
 * By             : H422337
 * On             : Sep 14,2020
 * Description    : ASDS-2753 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 10,2020
 * Description    : ASDS-3140 UI enhancements  phase-2 bugfixes
 *
 * By             : H422336
 * On             : Sep 15,2020
 * Description    : ASDS-3037 UI Enhancements Phase-II
 *
 * By             : H422337
 * On             : Sep 18,2020
 * Description    : ASDS-3025 UI enhancements as part of phase-2

 * By             : H422336
 * On             : Sep 16,2020
 * Description    : ASDS-2744 UI Enhancements Phase-II
 *
 * By             : H422337
 * On             : Sep 21,2020
 * Description    : ASDS-3030 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 24,2020
 * Description    : ASDS-3026 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 23, 2020
 * Description   : ASDS - 3020 - UI Enhancements for Phase - II
 *
 * By             : H422337
 * On             : Sep 25,2020
 * Description    : ASDS-3028 APU enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 25,2020
 * Description    : ASDS-3222 APU enhancements as part of phase-2 bugfix
 *
 * By             : H422337
 * On             : Sep 29,2020
 * Description    : ASDS-3257 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 30,2020
 * Description    : ASDS-3230 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 30,2020
 * Description    : ASDS-3417 APU enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 29, 2020
 * Description   : ASDS - 3233 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 1, 2020
 * Description   : ASDS-3481 bugFix for Phase - II
 *
 * By             : H422337
 * On             : Oct 05,2020
 * Description    : ASDS-3264 APU UI enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3235 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3438 UI Enhancements  phase-2 bugfixes
 *
 * By            : H422336
 * On            : Oct 11, 2020
 * Description   : ASDS - 3255 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2 bugfixes
 *
 * By            : H422337
* On            : Oct 13, 2020
* Description   : ASDS - 3626 UI Enhancements for Phase - II
*
*By            : H422337
 * On            : Oct 13, 2020
 * Description   : ASDS-3627 UI Enhancements for phase-2 bugfixes
 *
 * By            : H422337
 * On            : Oct 13, 2020
 * Description   : ASDS-3564 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Oct 15, 2020
 * Description   : ASDS-3558 UI Enhancements for phase-2
 *
 * By            : H422335
 * On            : 14 Oct 2020
 * Description   : ASDS-3035 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422337
 * On            : Oct 16, 2020
 * Description   : ASDS-3737   Non-MSA key only unit price not updated bug fix
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Oct, 23 2020
 * Description   : ASDS-3784 UI Enhancements for Phase-II bug fixes
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 * By            : H422337
 * On            : Nov 19, 2020
 * Description   : ASDS -4084 -UI Enhancements for Phase - II  bug fix -Error should not be displayed in the step 1 of product configuration
 *
 ******************************************************************************/

import Action from './Action';
import ActionConstants from '../action-constants';
import ConfigureAPUAPI from '../../API/configureAPUAPI';
import CartDetails from '../../API/cart-detials-api';
import { CheckoutConstants, ApuErrorLabels, CheckoutUILabels } from './../../constants/checkout-constants';
import { validateAPUSerialNumber, validateSoldTo, validateContractNum, validateAPUServiceOrderNumber, validateAircraftOEM, indexOfAll } from './../../utils/configuration-validations';
import CartDetailsActions from './cart-details-actions';
import { logError } from '../../../../utils/console-utility';
import routeConstants from 'modules/checkout/constants/route-constants';
import OrderSummaryActions from './order-summary-actions';
import ProductAlertActions from './products-alerts-action';
import { NotifUpdateI } from 'modules/checkout/utils/checkout-interfaces';
import ConfigureProductAPI from 'modules/checkout/API/configureProductAPI';

const validateApuCustType = function (custType: string) {
  if (custType !== null && custType !== '') {
    return true;
  }
  else {
    return false;
  }
};

// TODO: Need to validate if APU serial number already added to cart or not
/* const presentInCart = (cartSerials) => (apuSerialNumber) => cartSerials.indexOf(apuSerialNumber) > -1 ? 'This APU serial number is already configured and added in the cart.' +
   ' Please enter new APU serial number to move ahead (or) modify the existing product in your cart. ' : '';
*/

const validateMsaInputData = (inputData: any, validateFields: any, serialsInCart: [],getState) => {
  const validatedData = inputData.map((feature) => {
    let errorMsg = {
      soldToError: '',
      contractNumError: '',
      aircraftOemError: '',
      serialNumberError: '',
    };
    let validInputData = true;

    // ['soldTo', 'contractNo', 'aircraftOem', 'serialNum', 'cartDuplicateSl']
    if (validateSoldTo(feature.soldTo)) {
      validInputData = false;
      if (validateFields.indexOf('soldTo') > -1) {
        errorMsg.soldToError = ApuErrorLabels.MSA_SOLDTO_ERROR_EMPTY;
      }
    }

    if (validateContractNum(feature.contractNo)) {
      validInputData = false;
      if (validateFields.indexOf('contractNo') > -1) {
        errorMsg.contractNumError = ApuErrorLabels.MSA_CONTRACT_ERROR;
      }
    }

    if (validateAircraftOEM(feature.aircraftOem)) {
      validInputData = false;
      if (validateFields.indexOf('aircraftOem') > -1) {
        errorMsg.aircraftOemError = ApuErrorLabels.MSA_OEM_ERROR;
      }
    }

    if (!feature.serialNumber) {
      validInputData = false;
      if (validateFields.indexOf('serialNum') > -1) {
        errorMsg.serialNumberError = ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY;
      }
    }
    else if (validateAPUSerialNumber(feature.serialNumber)) {
      validInputData = false;
      if (validateFields.indexOf('serialNum') > -1) {
        errorMsg.serialNumberError = ApuErrorLabels.MSA_SERIAL_ERROR_INVALID;
      }
    }
    else {
      const serialNumberList = inputData.map((obj) => obj.serialNumber);
      const duplicateIndex = indexOfAll(serialNumberList, feature.serialNumber);
      // check of the duplicates, if found update the error msg.
      if (duplicateIndex.length > 1) {
        errorMsg.serialNumberError = ApuErrorLabels.MSA_DUPLICATE_SERIAL_ERROR;
        validInputData = false;
      }
      // Check if serial number is duplicated from the cart items
      if (validateFields.indexOf('cartDuplicateSl') > -1) {
        const cartDupSerNo = indexOfAll(serialsInCart, feature.serialNumber);

        let allSerialNumberData = getState()?.apuOrderDetails?.apuOrderDetails?.data?.orders?.map(product => {
              return product?.products[0].subProducts[0].platforms[0].serialNumber
          });          
        console.log('allSerialNumberData', allSerialNumberData);
        const orderDupSerNo = indexOfAll(allSerialNumberData, feature.serialNumber);
        
        if (cartDupSerNo.length || orderDupSerNo?.length) {
          errorMsg.serialNumberError = ApuErrorLabels.DUPLICATE_SERIAL_CART_ERROR; // This Serial Number is already configured and added in the cart. Please enter new Serial Number to move ahead (or) modify the existing
          validInputData = false;
        }
      }
    }
    return { ...feature, ...errorMsg, validInputData };
  });
  const errors = validatedData.filter((feature) => {
    return !feature.validInputData;
  });

  const hasErrors = errors.length > 0;  // returns true if there is any error msg present in validated array
  return { validatedData, hasErrors };
};

const validateNonMsaInputData = (inputData: any, validateFields: any, serialsInCart: [], getState) => {
  const validatedData = inputData.map((feature) => {
    let errorMsg = {
      oemError: '',
      serialNumberError: '',
      paymentOptionError: '',
      optionError:''
    };
    let validInputData = true;

    // ['aircraftOem', 'serialNum', 'paymentSel']
    if (validateAircraftOEM(feature.acOem)) {
      validInputData = false;
      if (validateFields.indexOf('aircraftOem') > -1) {
        errorMsg.oemError = ApuErrorLabels.NONMSA_OEM_ERROR;
      }
    }

    if ('purchaseOrderNumber' in feature) {
      errorMsg['purchaseOrderNumberError'] = '';
      if (!feature.purchaseOrderNumber) {
        validInputData = false;
        if (validateFields.indexOf('purchaseOrderNumber') > -1) {
          errorMsg['purchaseOrderNumberError'] = ApuErrorLabels.NONMSA_PURCHASE_ORDER_ERROR;
        }
      } else if (typeof feature.validateQuantity !== 'undefined' && !feature.validateQuantity) {
        validInputData = false;
        if (validateFields.indexOf('purchaseOrderNumber') > -1) {
          errorMsg['purchaseOrderNumberError'] = ApuErrorLabels.NONMSA_PURCHASE_ORDER_QUANTITY_ERROR;
        }
      }
    }

    if (!feature.serialNumber) {
      validInputData = false;
      if (validateFields.indexOf('serialNum') > -1) {
        errorMsg.serialNumberError = ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY;
      }
    }
    else if (validateAPUSerialNumber(feature.serialNumber)) {
      validInputData = false;
      if (validateFields.indexOf('serialNum') > -1) {
        errorMsg.serialNumberError = ApuErrorLabels.MSA_SERIAL_ERROR_INVALID;
      }
    }
    else {
      // Inputdata check the non error val
      const serialNumberList = inputData.map((obj) => obj.serialNumber);
      
      const duplicateIndex = indexOfAll(serialNumberList, feature.serialNumber);
      
      // check of the duplicates, if found update the error msg.
      if (duplicateIndex.length > 1) {
        errorMsg.serialNumberError = ApuErrorLabels.NONMSA_DUPLICATE_SERIAL_ERROR; 
        validInputData = false;
      }

      if (validateFields.indexOf('cartDuplicateSl') > -1) {
        const cartDupSerNo = indexOfAll(serialsInCart, feature.serialNumber);

        let allSerialNumberData = getState()?.apuOrderDetails?.apuOrderDetails?.data?.orders?.map(product => {
              return product?.products[0].subProducts[0].platforms[0].serialNumber
          });          
          console.log('allSerialNumberData', allSerialNumberData);
        const orderDupSerNo = indexOfAll(allSerialNumberData, feature.serialNumber);
        
        if (cartDupSerNo.length || orderDupSerNo?.length) {
          errorMsg.serialNumberError = ApuErrorLabels.DUPLICATE_SERIAL_CART_ERROR; // This Serial Number is already configured and added in the cart. Please enter new Serial Number to move ahead (or) modify the existing
          validInputData = false;
        }
      }
    }
    

    if ('serviceOrderNumber' in feature) {
      errorMsg['serviceOrderNumberError'] = '';
      if (!feature.serviceOrderNumber) {
        validInputData = false;
        if (validateFields.indexOf('serviceNum') > -1) {
          errorMsg['serviceOrderNumberError'] = ApuErrorLabels.NONMSA_SERVICE_ORDER_EMPTY_ERROR;
        }
      }
      else if (validateAPUServiceOrderNumber(feature.serviceOrderNumber)) {
          validInputData = false;
          if (validateFields.indexOf('serviceNum') > -1) {
            errorMsg['serviceOrderNumberError'] = ApuErrorLabels.NON_MSA_SERVICE_ORDER_ERROR_INVALID;
            }
      }
      else {
        const ServiceOrderNumberList = inputData.map((obj) => obj.serviceOrderNumber);
        const duplicateIndex = indexOfAll(ServiceOrderNumberList, feature.serviceOrderNumber);
      // check of the duplicates, if found update the error msg.
        if (duplicateIndex.length > 1) {
        errorMsg['serviceOrderNumberError'] = ApuErrorLabels.NONMSA_SERVICE_ORDER_DUBLICATE_ERROR;
        validInputData = false;
      }

      // Check if serviceOrder number is duplicated from the cart items
        if (validateFields.indexOf('cartDuplicateSO') > -1) {
        const cartDupSerNo = indexOfAll(serialsInCart, feature.serviceOrderNumber);
        if (cartDupSerNo.length) {
          errorMsg['serviceOrderNumberError'] = ApuErrorLabels.NONMSA_SERVICE_ORDER_DUBLICATE_CART_ERROR;
          validInputData = false;
        }
      }
      }
    }

    if ('optionId' in feature) {
      errorMsg['optionError'] = '';
      if (!feature.optionId) {
        if (validateFields.indexOf('subscriptionPeriod') > -1) {
          validInputData = false;
          errorMsg['optionError'] = ApuErrorLabels.NON_MSA_KEY_ONLY_PERIOD;
        }
      }
    }


    // if (!feature.paymentOption) {
    //   validInputData = false;
    //   if (validateFields.indexOf('paymentSel') > -1) {
    //     errorMsg.paymentOptionError = ApuErrorLabels.NONMSA_PAYMENT_ERROR;
    //   }
    // }
    return { ...feature, ...errorMsg, validInputData };
  });

  const errors = validatedData.filter((feature) => {
    return !feature.validInputData;
  });

  const hasErrors = errors.length > 0;  // returns true if there is any error msg present in validated array
  return { validatedData, hasErrors };
};

const saveToCartObjMapper = function (productDetails: any, opType: any, soldTo: any, productInCart?:any) {
  console.log(opType,productInCart);
  let cartObj;
  const apuLineItemDetails = productDetails.productData.map(product => {
    if (productDetails.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
      return {
        soldTo: product.soldTo,
        distributionNo: product.contractNo,
        expiryDate: new Date(product.expirationDate).toISOString(),
        model: product.aircraftOem,
        unitPrice: parseFloat(product.unitPrice),
        serialNo: product.serialNumber,
        subProductId: product.subProductId,
      };
    }
    else {
      return {
        subProductDesc : product.subProductDesc,
        distributionNo: (product.purchaseOrderNumber || product.serviceOrderNumber) ? product.purchaseOrderNumber || product.serviceOrderNumber : '',
        serialNo: product.serialNumber,
        model: product.acOem,
        soldTo: soldTo,
        optionAvailable: product.optionAvailable ? product.optionAvailable : false,
        optionId : product.optionId ? product.optionId : 0,
        term : product.term ? product.term : '',
        subProductId: product.subProductId,
        unitPrice: parseFloat(product.unitPrice),
      };
    }
  });

  if (productDetails.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
    cartObj = {
        apuMsaSerials: apuLineItemDetails,
        msa: true,
    };
  } else {
    cartObj = {
      apuNonMsaSerials: apuLineItemDetails,
      msa: false,
    };
  }

  if (opType === CheckoutConstants.OPERATION_TYPE_SAVE ) {
  return {
    cart: {
      seq :productDetails.cartSeq ? productDetails.cartSeq : 0,
      productsRequest: [{
        customerType: cartObj,
        prodDesc: productDetails.productDesc,
        prodId: productDetails.productId,
        prodName: productDetails.productName,
        system: productDetails.system,
        categoryName: productDetails.categoryName
      }]
    }
  };
}
else {

  return {
    cart: {
      seq: productDetails.cartSeq,
      productsRequest: [{
        id: productDetails.id,
        cartSeq: productDetails.cartSeq,
        customerType: cartObj,
        prodDesc: productDetails.productDesc,
        prodId: productDetails.productId,
        prodName: productDetails.productName,
        system: productDetails.system,
        categoryName: productDetails.categoryName
      }]
    }
  };

}

  // return {
  //   userId: productDetails.userID,
  //   soldTo: soldTo,
  //   operationType: opType,
  //   products: [{
  //     productSeq: productDetails.productSeq, // default value is 0. If edit, gets the edit cart line item productSeq
  //     productId: productDetails.productId,
  //     productName: productDetails.productName,
  //     system: productDetails.system,
  //     categoryName: productDetails.categoryName,
  //     serialNo: serials,
  //     apuProductConfig: { customerType: productDetails.customerType, apuLineItemDetails: apuLineItemDetails },
  //   }]
  // };
};

function confirmConfigurationDetails(dispatch, getState) {
    let {
      productsInCart,
      nonMsaConfigData,
      msaConfigData,
      nonMsaServiceOrderConfigData,
      nonMsaKeyOnlyOrderConfigData,
      system,
      totalPrice,
      categoryName,
      customerType,
      purchaseType,
      customerOrderType,
      product,
      editCartAPUProductDetails
    } = getState().configAPUData.payload;
    const userID = getState().userValidationData.payload.userInfo.customer_sub;
    const soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
    let productData = '';

    if (customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
      productData = msaConfigData;
    } else {
    if (customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
      productData = nonMsaServiceOrderConfigData;
    }
    else if (customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO) {
      productData = nonMsaConfigData;
    }
    else{
       productData = nonMsaKeyOnlyOrderConfigData;
    }
  }
    let productDetails = {
      ...product,
      system,
      categoryName,
      customerType,
      purchaseType,
      totalPrice,
      userID,
      productData,
      productSeq: editCartAPUProductDetails.productSeq,
      seq: editCartAPUProductDetails.seq,
      id : editCartAPUProductDetails.id,
      cartSeq: editCartAPUProductDetails.cartSeq
    };
    productsInCart = [...productsInCart, productDetails];

    dispatch({
      type: ActionConstants.SET_ALERT_MODEL,
      payload: {
          showAlertMsg: false,
          isAddToCartSuccess: false
      }
    });

    if (!productDetails.productSeq && !productDetails.seq) {
      const cartProduct = saveToCartObjMapper(productDetails, CheckoutConstants.OPERATION_TYPE_SAVE, soldTo, productsInCart);
      productsInCart = [...productsInCart, cartProduct];

      dispatch({
        type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
        payload: {
          addProductToCartInProgress: true,
        },
      });

      CartDetails.saveProductToCart(cartProduct, productDetails.userID).then(response => {
      let isAddToCartSuccess = false;

      if (response) {
        isAddToCartSuccess = true;
        dispatch({ // dispatching action to add the product to CART items.
            type: ActionConstants.ADD_APU_PRODUCT_TO_CART,
            payload: {
              productsInCart: productsInCart,
            }
          });
        dispatch(ProductAlertActions.setGenricFields(system));
        dispatch({
          type: ActionConstants.OPEN_CART_ICON,
          payload: {
            openCartIcon: true
          }
        });
        dispatch({
          type: ActionConstants.CLOSE_APU_MODEL,
          payload: {}
        });
        dispatch({   // dispatching action to reset the configure product data.
          type: ActionConstants.APU_RESET_CONFIGURATION,
          payload: {}
        });
        /**
         * This will update the cart Count for user
         * Getting selected cart list, as it used to display MSA delete warning when user tries to change address
         */
        CartDetailsActions.getCartData(userID, 'both')(dispatch, getState); //
        }
        // common dispatchers after save process - irespective of outcome

      dispatch({   // dispatching action to update last product added to cart
          type: ActionConstants.UPDATE_LAST_PROD_CART,
          payload: {
            lastProdAddedToCart: productDetails.productName,
          }
        });
      dispatch({
          type: ActionConstants.SET_ALERT_MODEL,
          payload: {
            showAlertMsg: true,
            isAddToCartSuccess: isAddToCartSuccess
          }
        });
      dispatch({   // dispatching action to hide add to cart loader
          type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
          payload: {
            addProductToCartInProgress: false,
          }
        });
      });
  } else {
    dispatch({
      type: ActionConstants.SET_TOASTER,
      payload: {
          notify: 'bottom-right'
      }
  });
  // EDIT CART
    const cartProduct = saveToCartObjMapper(productDetails, CheckoutConstants.OPERATION_TYPE_EDIT, soldTo);
    productsInCart = [...productsInCart, cartProduct];

    dispatch({
      type: ActionConstants.EDIT_PRODUCT_TO_CART_LOADER,
      payload: {}
    });

    dispatch({  // dispatching action to hide edit pop up
      type: ActionConstants.HIDE_EDIT_MODEL_APU,
      payload: {}
    });
    CartDetails.editProductToCart(cartProduct, productDetails.userID).then(response => {
      let isUpdateToCartSuccess = false;
      if (response) {
        isUpdateToCartSuccess = true;
        dispatch({ // dispatching action to add the product to CART items.
          type: ActionConstants.ADD_APU_PRODUCT_TO_CART,
          payload: {
            productsInCart: productsInCart,
          }
        });
        dispatch({   // dispatching action to update last product added to cart
          type: ActionConstants.UPDATE_LAST_PROD_CART,
          payload: {
            lastProdAddedToCart: productDetails.productName,
          }
        });
        dispatch(
          // get cart products & updates cart count
          CartDetailsActions.getCartData(userID, 'both')
        );
        dispatch(
          // updates order summary
          OrderSummaryActions.getOrderSummary(userID)
        );
        dispatch({
          type: ActionConstants.SET_ALERT_MODEL,
          payload: {
            showAlertMsg: true,
            isAddToCartSuccess: isUpdateToCartSuccess
          }
        });
      } else {
        dispatch({
          type: ActionConstants.SET_ALERT_MODEL,
          payload: {
            showAlertMsg: true,
            isAddToCartSuccess: isUpdateToCartSuccess
          }
        });
        dispatch(
          CartDetailsActions.showErrorOnEditProduct(product.productName)
        );
      }


    }).finally(// common dispatchers after edit process - irespective of outcome
      dispatch({   // dispatching action to reset the configure product data.
        type: ActionConstants.APU_RESET_CONFIGURATION,
        payload: {}
      })
      );

    }
}
// Using this function validating service Order Row data  when click Next button and then  add a new row  when click a ADD button
function ValidateNonMSASOData(dispatch, getState, isAddNewRow: boolean){
    const apuPayload = getState().configAPUData.payload;
    let apuactiveTab = getState().configAPUData.payload.apuactiveTab;
    const acOem = apuPayload.aircraftOEMs;
    const previousRowData = apuPayload.nonMsaServiceOrderConfigData;
    let EnablenextButton: boolean = true;
    let serviceOrders: any = [];
    previousRowData.map((rowValue) => {
      serviceOrders.push(rowValue.serviceOrderNumber.trim());
       });
    let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
    const validationFields = ['aircraftOem', 'serialNum', 'serviceNum', 'cartDuplicateSl'];
    // Validate Serial number and mandatory fields
    const { validatedData, hasErrors } = validateNonMsaInputData(previousRowData, validationFields, serialsIncart, getState);
    let updatedProductData;

    if (hasErrors) {
      updatedProductData = [...validatedData];
      dispatch({
        type: ActionConstants.APU_NONMSA_SO_ADD_CONFIGURATION,
        payload: {
          updatedProductData,
          enableNextBtn: !hasErrors
        }
      });
    } else {
      // There is no errors in data after validating Serial numbers and mandatory fields
      // Validating  combination of serviceOrder Numbers using api call
      dispatch({
        type: ActionConstants.APU_NONMSA_SO_VALIDATE_API_ERROR,
        payload: {
          isValidateServiceOrder: true,
          isValidateServiceOrderSuccess: true,
        }
      });

      ConfigureAPUAPI.validateServiceOrder(serviceOrders).then((res) => {
        dispatch({
          type: ActionConstants.APU_NONMSA_SO_VALIDATE_API_ERROR,
          payload: {
            isValidateServiceOrder: false,
            isValidateServiceOrderSuccess: true,
          }
        });
        if (res.data && res.data.result.length !== 0) {
 // Handle invalid service order numbers and update errorMsg to  repective row data
    let previousSORowData = [...validatedData];

    res.data.result.filter((ServiceOrders) => {
      if (ServiceOrders.status === CheckoutConstants.NON_MSA_SERVICE_ORDER_VALIDATE_STATUS){
        EnablenextButton = false;
        const serviceOrderNoIndex = previousSORowData.findIndex((x: any) => (x.serviceOrderNumber) === ServiceOrders.distributionNo );
        if (serviceOrderNoIndex !== -1) {
          previousSORowData[serviceOrderNoIndex].serviceOrderNumberError = ServiceOrders.message;
          previousSORowData[serviceOrderNoIndex].validInputData = false;
           }
          }
    });
    updatedProductData = [...previousSORowData];

  }

        if (!isAddNewRow && EnablenextButton ) { // If click come from next button navigating to confirm tab without error
          apuactiveTab = apuactiveTab + 1;
          dispatch({
            type: ActionConstants.APU_GOTO_CONFIRM_CONFIG,
            payload: {
              apuactiveTab,
            }
          });
  }
  else if (EnablenextButton) {   // If click come from Add Button add a new row if there is no error
    EnablenextButton = false;

    const purchaseType = previousRowData[0].paymentOption;
    const price = previousRowData[0].unitPrice;
    const newEmptyRow = {
          acOem: acOem,
          oemError: '',
          serialNumber: '',
          serialNumberError: '',
          serviceOrderNumber: '',
          serviceOrderNumberError: '',
          paymentOption: purchaseType,
          paymentOptionError: '',
          unitPrice: price,
          extendedPrice: '0.0',
          validInputData: false,
          subProductId: purchaseType,
          subProductDesc: ''
        };
    updatedProductData = [...validatedData, newEmptyRow];

    }
        let totalPrice = ConfigureAPUActions.updateTotalPrice(
      updatedProductData
    );
        dispatch({
        type: ActionConstants.APU_NONMSA_SO_ADD_CONFIGURATION,
        payload: {
          updatedProductData,
          totalPrice: totalPrice,
          enableNextBtn: EnablenextButton
        }
      });
  })
  .catch((err) => {
         logError('Validate NonMSA ServiceOrderNubmer', err);
         dispatch({
          type: ActionConstants.APU_NONMSA_SO_VALIDATE_API_ERROR,
          payload: {
            isValidateServiceOrder: false,
            isValidateServiceOrderSuccess: false,
          }
        });
  });
   }
}

class ConfigureAPUActions extends Action {
  static onClickAPUConfigureButton(product: any, system: string, categoryName: string) {  // this Action will be called when user click on the "CONFIGURE" button of the product"
    return (dispatch, getState) => {
      dispatch(ProductAlertActions.hideAlert());
      let productsInCart = getState().configAPUData.payload.productsInCart;
       let aircraftOEMType = ''
      if(product?.productName?.toLowerCase().includes(CheckoutConstants.APU_BOEING_PRODUCT_NAME)) {
        aircraftOEMType = '131-9B';
      }
      else if(product?.productName?.toLowerCase().includes(CheckoutConstants.APU_AIRBUS_PRODUCT_NAME)) {
        aircraftOEMType = '131-9A';
      }
      const inCompatibleProducts = ProductAlertActions.checkInCompatibleProducts(productsInCart, categoryName);
      if (inCompatibleProducts.length > 0) { // this product is in compatible to add to cart.
        dispatch({
          type: ActionConstants.SHOW_INCOMPATIBLE_TO_ADD_TO_CART,
          payload: {
            inCompatibleProducts: true
          }
        });
      } else {  // we can add this product to cart.
        dispatch({
          type: ActionConstants.APU_CONFIGURE_PRODUCT_MODEL,
          payload: {
            product,
            system,
            categoryName,
            configureAPUModelOpen: true,
            aircraftOEMType,
          }
        });
        dispatch(ProductAlertActions.setGenricFields(system));
      }
    };
  }
  // Method to get subproduct object based on customer type
  static getSubProductForCustomerType (customerType: string, featuresMasterData: any) {
    return featuresMasterData.filter((featureItem) => featureItem.distributionType === customerType );
  }
  // Method to get subProduct based on subProductId passed
  static getSubProductForSubProductId (subProductId: string, featuresMasterData: any) {
    return featuresMasterData.filter((featureItem) => featureItem.subProductId === subProductId );
  }
  //Method to get Non-MSA key only order options values
  static getOptionValueForOptionId (OptionId: string, optionsData: any) {
    return optionsData.filter((options) => options.optionId === OptionId );
  }
  static saveCustomerType(customerType: string) {
    return (dispatch, getState) => {
      const apuProductDatas = getState().configAPUData.payload.msaConfigData;
      const acOem = getState().configAPUData.payload.aircraftOEMs;
      let apuProductData = [...apuProductDatas];
      // initialising the soldto of the selected account to intial state of msa product data
      let soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      apuProductData.forEach((prodData) => {
        prodData.soldTo = soldTo;
        prodData.aircraftOem = acOem;
      });

      dispatch({
        type: ActionConstants.APU_SAVE_CUSTOMER_TYPE,
        payload: {
          customerType: customerType,
          apuProductData: apuProductData,
          enableNextBtn: validateApuCustType(customerType),
        }
      });
    };
  }

  static saveCustomerOrderType(customerOrderType: string, errorMsg: string) {
      return  (dispatch, getState) => {
        let  nonMsaProductDatas:any =[]
        if(customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY){
         nonMsaProductDatas = getState().configAPUData.payload.nonMsaKeyOnlyOrderConfigData;
        }
        else if(customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
          nonMsaProductDatas = getState().configAPUData.payload.nonMsaServiceOrderConfigData;

        }
        else {
          nonMsaProductDatas = getState().configAPUData.payload.nonMsaConfigData
        }
        const acOem = getState().configAPUData.payload.aircraftOEMs;

        let nonMsaProductData = [...nonMsaProductDatas];
        // initialising the soldto of the selected account to intial state of msa product data
        nonMsaProductData.forEach((prodData) => {
          prodData.acOem = acOem;
        });
        dispatch({
        type: ActionConstants.APU_SAVE_CUSTOMER_ORDER_TYPE,
        payload: {
          customerOrderType: customerOrderType,
          customerOrderTypeErrorMessage: errorMsg,
          enableNextBtn: false,
          nonMSAconfigData: nonMsaProductData
        }
      });
      };
  }

  // static getAircraftOEM(productId: string) {
  //   return () => {
  //     const AircraftOEMPromise = ConfigureAPUAPI.getAircraftOEM(productId);
  //     AircraftOEMPromise.then(response => {
  //       logInfo(response);
  //     });
  //   };
  // }

  static updateAircraftOem(aircraftOEM: string, index: number) {
    return (dispatch, getState) => {
      const apuProductDatas = getState().configAPUData.payload.nonMsaConfigData;
      let apuProductData = [...apuProductDatas];
      apuProductData[index].acOem = aircraftOEM;

      const validationFields = ['aircraftOem'];
      const { validatedData, hasErrors } = validateNonMsaInputData(
        apuProductData,
        validationFields, [],
        getState
      );

      dispatch({
        type: ActionConstants.APU_UPDATE_AIRCRAFT_OEM,
        payload: {
          apuProductData: validatedData,
          enableNextBtn: !hasErrors
        }
      });
    };
  }

  static updateSerial(updatedSerialNumber: string, index: number) {
    // validate and update the serial number
    return (dispatch, getState) => {
      if (('' + updatedSerialNumber).length <= 8) {
        const apuPayload = getState().configAPUData.payload;
        let apuProductData = [...apuPayload.nonMsaConfigData];
        apuProductData[index].serialNumber = updatedSerialNumber;
        apuProductData[index].serialNumberError = '';
        let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
        const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum', 'cartDuplicateSl'];
        const { validatedData, hasErrors } = validateNonMsaInputData(apuProductData, validationFields, serialsIncart, getState);
        let totalPrice = ConfigureAPUActions.updateTotalPrice(
          apuProductData
        );
        dispatch({
          type: ActionConstants.APU_UPDATE_SERIAL_NUMBER,
          payload: {
            apuProductData: validatedData,
            totalPrice,
            enableNextBtn: !hasErrors
          }
        });
      }
    };
  }

  static updatePurchaseType(purchaseType: string, index: number) {
    return (dispatch, getState) => {
      const apuProductDatas = getState().configAPUData.payload.nonMsaConfigData;
      let apuProductData = [...apuProductDatas];
      apuProductData[index].paymentOption = purchaseType;
      apuProductData[index].paymentOptionError = '';
      let subProducts =  ConfigureAPUActions.getSubProductForSubProductId( purchaseType , getState().configAPUData.payload.featuresMasterData);
      apuProductData[index].subProductId = purchaseType;
      apuProductData[index].unitPrice = subProducts[0].price;
      // updating total price
      let totalPrice = ConfigureAPUActions.updateTotalPrice(
        apuProductData
      );
      dispatch({
        type: ActionConstants.APU_UPDATE_PURCHASE_TYPE,
        payload: {
          apuProductData,
          enableNextBtn: true,
          totalPrice: totalPrice
        }
      });
    };
  }

  static updateTotalPrice(features: any) {
    let totalPrice = 0.0;
    features.forEach(feature => {
      totalPrice += feature.unitPrice;
    });
    return totalPrice;
  }

  static addNewRow() {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      const previousRowData = apuPayload.nonMsaConfigData;
      const acOem = apuPayload.aircraftOEMs;

      let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
      const validationFields = ['aircraftOem', 'serialNum', 'paymentSel', 'cartDuplicateSl', 'purchaseOrderNumber'];
      const { validatedData, hasErrors } = validateNonMsaInputData(previousRowData, validationFields, serialsIncart, getState);
      let updatedProductData;

      if (hasErrors) {
        updatedProductData = [...validatedData];
      } else {
        const purchaseType = previousRowData[0].paymentOption;
        const price = previousRowData[0].unitPrice;
        const newEmptyRow = {
          acOem: acOem,
          oemError: '',
          serialNumber: '',
          serialNumberError: '',
          paymentOption: purchaseType,
          paymentOptionError: '',
          unitPrice: price,
          extendedPrice: '0.00',
          validInputData: false,
          subProductId: purchaseType,
          subProductDesc: '',
          purchaseOrderNumber: '',
          purchaseOrderNumberError: '',
          expiryDate: ''
      };
        updatedProductData = [...validatedData, newEmptyRow];
      }

      dispatch({
        type: ActionConstants.APU_NONMSA_ADD_CONFIGURATION,
        payload: {
          updatedProductData,
          enableNextBtn: false
        }
      });
    };
  }

  static deleteRow(selectedRows: any) {
    return (dispatch, getState) => {
      let previousRowData = getState().configAPUData.payload.nonMsaConfigData;
      const apuModel = getState().configAPUData.payload.aircraftOEMs;
      let updatedProductData;
      let enableNextBtn;
      let totalPrice;

      if (previousRowData.length >= 1) {
        previousRowData = previousRowData.filter((obj) => {
        const indexFromSelectedRowData = selectedRows.findIndex((x: any) => (x.serialNumber === obj.serialNumber));
        let returnFilterObj;
        if (indexFromSelectedRowData === -1) {
            returnFilterObj = obj;
        }
        return returnFilterObj;
      });

        if (previousRowData.length !== 0) {
          const validationFields = ['aircraftOem', 'serialNum', 'paymentSel'];
          const { validatedData, hasErrors } = validateNonMsaInputData(
            previousRowData,
            validationFields, [], getState
          );

          updatedProductData = [...validatedData];
          enableNextBtn = !hasErrors;

          totalPrice = ConfigureAPUActions.updateTotalPrice(
            previousRowData
          );
        } else {
          const newEmptyRow = {
            acOem: apuModel,
            oemError: '',
            serialNumber: '',
            serialNumberError: '',
            paymentOption: '',
            paymentOptionError: '',
            unitPrice: 0,
            extendedPrice: '0.0',
            subProductId: '',
            subProductDesc: '',
            purchaseOrderNumber: '',
            purchaseOrderNumberError: '',
            expiryDate: '',
            validInputData: false
          };

          updatedProductData = [...previousRowData, newEmptyRow];
          totalPrice = ConfigureAPUActions.updateTotalPrice(previousRowData);
      }
    }
      dispatch({
        type: ActionConstants.APU_NONMSA_DELETE_CONFIGURATION,
        payload: {
          updatedProductData: updatedProductData,
          totalPrice: totalPrice,
          enableNextBtn: enableNextBtn
        }
      });
    }
  }

  static gotoCustomerCategoryTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.APU_GOTO_CUSTOMER_CATEGORY_TAB,
        payload: {
          apuactiveTab: CheckoutConstants.CONFIGURE_CUSTOMER_CATEGORY_TAB
        }
      });
    };
  }

  static gotoProductConfigureTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.GOTO_PRODUCT_CONFIGURE_TAB,
        payload: {
          apuactiveTab: CheckoutConstants.CONFIGURE_FEATURES_TAB
        }
      });
    };
  }

  static gotoNonMsaProductConfigureTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.GOTO_PRODUCT_CONFIGURE_TAB,
        payload: {
          apuactiveTab: CheckoutConstants.CONFIRM_CONFIGURATION_TAB
        }
      });
    };
  }

  /* activeTab==1  for Customer Category
  *  activeTab==2  for Add Serial Number
  *  activeTab==3  for Confirm Product Data Tab "ADD_TO_CART" button
  * */
  static gotoNextTabAPU() {
    return (dispatch, getState) => {
      let apuactiveTab = getState().configAPUData.payload.apuactiveTab;
      const nonMsaConfigData = getState().configAPUData.payload.nonMsaConfigData;
      const msaConfigData = getState().configAPUData.payload.msaConfigData;
      const lastNonMsaData = nonMsaConfigData[nonMsaConfigData.length - 1];
      const lastMsaData = msaConfigData[msaConfigData.length - 1];
      const enableNextbtn = lastNonMsaData.validInputData || lastMsaData.validInputData;

      if (getState().configAPUData.payload.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA) {
        if (apuactiveTab === 1) {
          apuactiveTab = apuactiveTab + 1;
          dispatch({
            type: ActionConstants.APU_GOTO_SERIAL_CONFIG,
            payload: {
              apuactiveTab,
              enableNextBtn: enableNextbtn,
            }
          });
        } else if (apuactiveTab === 2) {
          apuactiveTab = apuactiveTab + 1;

          if(getState().configAPUData.payload.customerOrderType !== '') {
            if (getState().configAPUData.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
              const validationFields = ['aircraftOem', 'serialNum', 'serviceNum', 'cartDuplicateSl'];
              let serialsIncart: any = ConfigureAPUActions.serialsIncart(getState().configAPUData.payload);
              const { hasErrors } = validateNonMsaInputData(getState().configAPUData.payload.nonMsaServiceOrderConfigData, validationFields, serialsIncart, getState);
              dispatch({
                type: ActionConstants.APU_GOTO_CONFIGURE_TAB,
                payload: {
                  apuactiveTab,
                  enableNextBtn: !hasErrors
                }
              });
            } else if (getState().configAPUData.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY) {
              const validationFields = ['aircraftOem', 'serialNum', 'serviceNum', 'cartDuplicateSl', 'subscriptionPeriod'];
              let serialsIncart: any = ConfigureAPUActions.serialsIncart(getState().configAPUData.payload);
              const { hasErrors } = validateNonMsaInputData(getState().configAPUData.payload.nonMsaKeyOnlyOrderConfigData, validationFields, serialsIncart, getState);
              dispatch({
                type: ActionConstants.APU_GOTO_CONFIGURE_TAB,
                payload: {
                  apuactiveTab,
                  enableNextBtn: !hasErrors
                }
              });
            }
            else {
              const validationFields = ['aircraftOem', 'serialNum', 'paymentSel', 'cartDuplicateSl'];
              let serialsIncart: any = ConfigureAPUActions.serialsIncart(getState().configAPUData.payload);
              const { hasErrors } = validateNonMsaInputData(getState().configAPUData.payload.nonMsaConfigData, validationFields, serialsIncart, getState);
              dispatch({
                type: ActionConstants.APU_GOTO_CONFIGURE_TAB,
                payload: {
                  apuactiveTab,
                  enableNextBtn: !hasErrors
                }
              });
            }
          } else {
            dispatch({
              type: ActionConstants.APU_SAVE_CUSTOMER_ORDER_TYPE,
              payload: {
                customerOrderType: '',
                customerOrderTypeErrorMessage: 'Please select a Key Purchase Type',
                enableNextBtn: false,
              }
            });
          }
        } else if (apuactiveTab === 3) {
          if (getState().configAPUData.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
            ValidateNonMSASOData(dispatch, getState, false);
          }



          else {

            let validationFields;
            let PreviousData;
            let isKeyOnly = false;

            if (getState().configAPUData.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO){
             validationFields = ['aircraftOem', 'serialNum', 'paymentSel', 'cartDuplicateSl', 'purchaseOrderNumber'];
             PreviousData = getState().configAPUData.payload.nonMsaConfigData;
            }
            else {
              validationFields = ['aircraftOem', 'serialNum', 'cartDuplicateSl', 'subscriptionPeriod'];
              PreviousData = getState().configAPUData.payload.nonMsaKeyOnlyOrderConfigData;
              isKeyOnly = true;
            }
            let serialsIncart = ConfigureAPUActions.serialsIncart(getState().configAPUData.payload);
            const { validatedData, hasErrors } = validateNonMsaInputData(PreviousData, validationFields, serialsIncart, getState);
            if (hasErrors) {
              dispatch({
                type: ActionConstants.APU_UPDATE_SERIAL_NUMBER,
                payload: {
                  apuProductData: validatedData,
                  enableNextBtn: !hasErrors,
                  isKeyOnly : isKeyOnly
                }
              });
            }
            else {
              apuactiveTab = apuactiveTab + 1;
              dispatch({
                type: ActionConstants.APU_GOTO_CONFIRM_CONFIG,
                payload: {
                  apuactiveTab,
                }
              });
            }
          }
        } else if (apuactiveTab === 4) {
          // Write non-MSA confirmation step code here
          confirmConfigurationDetails(dispatch, getState);
        }
      } else {
        if (apuactiveTab === CheckoutConstants.CONFIGURE_CUSTOMER_CATEGORY_TAB) {
          apuactiveTab = apuactiveTab + 1;
          dispatch({
            type: ActionConstants.APU_GOTO_SERIAL_CONFIG,
            payload: {
              apuactiveTab,
              enableNextBtn: enableNextbtn,
            }
          });
        } else if (apuactiveTab === CheckoutConstants.CONFIGURE_FEATURES_TAB) {
          // Validate all input data
          let serialsIncart: any = ConfigureAPUActions.serialsIncart(getState().configAPUData.payload);
          dispatch({
            type: ActionConstants.HIDE_VALIDATION_ERROR_MSG,
            payload: {
              showAPUValidationErrorMsg: true
            }
          });

          const apuProductData = getState().configAPUData.payload;
          const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum', 'cartDuplicateSl'];
          let { validatedData, hasErrors } = validateMsaInputData(apuProductData.msaConfigData, validationFields, serialsIncart,getState);

          if (hasErrors) {
          // has some error in serial line items
            dispatch({
              type: ActionConstants.APU_UPDATE_SERIAL_NUMBER_MSA,
              payload: {
                apuProductData: validatedData,
                enableNextBtn: !hasErrors,
              }
            });
          } else if (!apuProductData.acceptTermsStatus) {
            // terms not accepted
            dispatch({
              type: ActionConstants.UPDATE_APU_ACCEPT_TERMS_STATUS,
              payload: {
                acceptTermsStatus: apuProductData.acceptTermsStatus,
                acceptTermsErrorMsg: CheckoutUILabels.APU_TERMS_ERROR_MSG,
                enableNextBtn: false,
              }
            });
          } else {
            // serial line item passed and terms accepted
            apuactiveTab = apuactiveTab + 1;
            dispatch({
              type: ActionConstants.APU_GOTO_CONFIRM_CONFIG,
              payload: {
                apuactiveTab,
                nextbtn: 'ADD TO CART',
              }
            });
          }
        } else if (apuactiveTab === CheckoutConstants.CONFIRM_CONFIGURATION_TAB) {
          confirmConfigurationDetails(dispatch, getState);
        }
      }
    };
  }

  static gotoPrevTabAPU() {  // back button actions for the Configure Product model
    return (dispatch, getState) => {
      let apuactiveTab = getState().configAPUData.payload.apuactiveTab;
      dispatch({
        type: ActionConstants.APU_BACK_BUTTON_HANDLE,
        payload: {
          apuactiveTab: apuactiveTab - 1,
          nextbtn: 'Next',
          enableNextBtn: true
        }
      });
    };
  }

  static addMSARow() {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      const selectedSoldto = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      const previousRowData = apuPayload.msaConfigData;
      const acOem = getState().configAPUData.payload.aircraftOEMs;

      let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
      const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum', 'cartDuplicateSl'];
      const { validatedData, hasErrors } = validateMsaInputData(previousRowData, validationFields, serialsIncart,getState);
      let updatedProductData;

      if (hasErrors) {
        updatedProductData = [...validatedData];
      }
      else {
        const newEmptyRow = {
          soldTo: selectedSoldto,
          soldToError: '',
          contractNo: '',
          contractNumError: '',
          expirationDate: 'NA',
          aircraftOem: acOem,
          aircraftOemError: '',
          serialNumber: '',
          serialNumberError: '',
          unitPrice: 0.00,
          subProductId: ''
        };
        updatedProductData = [...validatedData, newEmptyRow];
      }

      dispatch({
        type: ActionConstants.APU_MSA_ADD_CONFIGURATION,
        payload: {
          updatedProductData,
          enableNextBtn: false
        }
      });
    };
  }

  static deleteMSARow(SelectedRows: []) {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      let previousRowData = apuPayload.msaConfigData;
      if (previousRowData.length >= 1) {
      previousRowData = previousRowData.filter((obj) => {
          const indexFromSelectedRowData = SelectedRows.findIndex((x: any) => (x.contractNo === obj.contractNo && x.aircraftOem === obj.aircraftOem && x.serialNumber === obj.serialNumber && x.soldTo === obj.soldTo));
          let returnFilterObj;
          if (indexFromSelectedRowData === -1) {
              returnFilterObj = obj;
          }
          return returnFilterObj;
      });
      const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum'];
      const { validatedData, hasErrors } = validateMsaInputData(previousRowData, validationFields, [],getState);

      dispatch({
          type: ActionConstants.APU_MSA_DELETE_CONFIGURATION,
          payload: {
            updatedProductData: validatedData,
            enableNextBtn: !hasErrors && apuPayload.acceptTermsStatus,
          }
        });
      }
    };
  }

  static updateMSASerial(updatedSerialNumber: string, index: number) {
    return (dispatch, getState) => {
        const apuPayload = getState().configAPUData.payload;
        let apuProductData = [...apuPayload.msaConfigData];
        apuProductData[index].serialNumber = updatedSerialNumber;
        let subProducts = ConfigureAPUActions.getSubProductForCustomerType(apuPayload.customerType, apuPayload.featuresMasterData);
        apuProductData[index].subProductId = subProducts[0]?.subProductId;
        apuProductData[index].unitPrice = subProducts[0]?.price;
        let totalPrice = ConfigureAPUActions.updateTotalPrice(
          apuProductData
        );
        let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
        const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum', 'cartDuplicateSl'];
        const { validatedData, hasErrors } = validateMsaInputData(apuProductData, validationFields, serialsIncart,getState);
        dispatch({
          type: ActionConstants.APU_UPDATE_SERIAL_NUMBER_MSA,
          payload: {
            apuProductData: validatedData,
            enableNextBtn: !hasErrors && apuPayload.acceptTermsStatus,
            totalPrice: totalPrice
          }
        });
    };
  }

  static updateSoldTo(soldTo: string, index: number) {
    return (dispatch, getState) => {
      const apuProductDatas = getState().configAPUData.payload.msaConfigData;
      let apuProductData = [...apuProductDatas];
      apuProductData[index].soldTo = soldTo;

      const validationFields = ['soldTo'];
      const { validatedData, hasErrors } = validateMsaInputData(apuProductData, validationFields, [],getState);

      dispatch({
        type: ActionConstants.APU_UPDATE_SOLD_TO_MSA,
        payload: {
          apuProductData: validatedData,
          enableNextBtn: !hasErrors,
        }
      });
    };
  }

  static updateContractNo(contractNo: string, index: number) {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      let apuProductData = [...apuPayload.msaConfigData];
      apuProductData[index].contractNo = contractNo;

      const conDetails = getState().configAPUData.payload.contractDetails;
      conDetails.map((conDetail) => {
        if (conDetail.contractNo === contractNo) {
          apuProductData[index].expirationDate = conDetail.expiryDate;
        }
      });
      let totalPrice = ConfigureAPUActions.updateTotalPrice(
        apuProductData
      );
      const validationFields = ['soldTo', 'contractNo'];
      const { validatedData, hasErrors } = validateMsaInputData(apuProductData, validationFields, [],getState);

      dispatch({
        type: ActionConstants.APU_UPDATE_AIRCRAFT_OEM_MSA,
        payload: {
          apuProductData: validatedData,
          enableNextBtn: !hasErrors && apuPayload.acceptTermsStatus,
          totalPrice: totalPrice
        }
      });
    };
  }
  static updateMSAAircraftOem(aircraftOEM: string, index: number) {
    return (dispatch, getState) => {
      const apuProductDatas = getState().configAPUData.payload.msaConfigData;
      let apuProductData = [...apuProductDatas];
      apuProductData[index].aircraftOem = aircraftOEM;
      const validationFields = ['soldTo', 'contractNo', 'aircraftOem'];
      const { validatedData, hasErrors } = validateMsaInputData(apuProductData, validationFields, [],getState);
      let totalPrice = ConfigureAPUActions.updateTotalPrice(
        apuProductData
      );
      dispatch({
        type: ActionConstants.APU_UPDATE_AIRCRAFT_OEM_MSA,
        payload: {
          apuProductData: validatedData,
          enableNextBtn: !hasErrors,
          totalPrice: totalPrice
        }
      });
    };
  }

  static resetconfigAPUData() {
    return (dispatch) => {

      dispatch({
        type: ActionConstants.APU_RESET_CONFIGURATION,
        payload: {}
      });
    };
  }

  /**
   * Method to redirect user to previous component. Resets component data.
   * @param currentPage
   */
  static onCancel(currentPage: any) {
    return dispatch => {
      dispatch({
        type: ActionConstants.SET_ALERT_MODEL,
        payload: {
          showAlertMsg: false,
          isAddToCartSuccess: false
        }
      });
      dispatch({
        type: ActionConstants.APU_RESET_CONFIGURATION,
        payload: {}
      });
      if (currentPage === routeConstants.MY_CART) {
        dispatch({
          type: ActionConstants.HIDE_EDIT_MODEL_APU,
          payload: {}
        });
      }
    };
  }

  // ASDS-1048 this will be called from OrderSummaryActions, to load cart data
  static setProductsInCart(data) {
    return {
      type: ActionConstants.LOAD_CART_DATA,
      payload: {
        productsInCart: data.result.cart.products
      }
    };
  }

  /**
   * Method to get subproducts/features data
   * @param productId
   */

  static getSubProductDetails(productId: string) {
    return (dispatch, getState) => {
      dispatch({
        type: ActionConstants.SET_SUB_PRODUCTS_LOADING,
        payload: {
          isProductFetching: true,
          isProductFetchSuccess: false
        }
      });
      let soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;

      // fetching subproduct details
      ConfigureProductAPI.getProductFeatureList(productId, soldTo)
        .then(response => {
          const productSeq = getState().configAPUData.payload.editCartAPUProductDetails.productSeq;
          if (productSeq === 0) {
            const subproducts = response.subProducts;
            let filteredSubProducts = subproducts.filter((product) => {
              return product.distributionType !== 'MSA';
            });

            if (filteredSubProducts.length === 1) {
              const apuProductDatas = getState().configAPUData.payload.nonMsaConfigData;
              let apuProductData = [...apuProductDatas];

              apuProductData[0].paymentOption = filteredSubProducts[0].subProductId;
              apuProductData[0].unitPrice = filteredSubProducts[0].price;
              apuProductData[0].subProductId = filteredSubProducts[0].subProductId;
            }
          }

          dispatch({
            type: ActionConstants.SET_APU_PRODUCT_FEATURES,
            payload: {
              featuresMasterData: response.subProducts,
              isProductFetching: false,
              isProductFetchSuccess: true
            }
          });
        })
        .catch(error => {
          logError('Error fetching and parsing features response', error);
          // setting error
          dispatch({
            type: ActionConstants.SET_APU_PRODUCT_FEATURES,
            payload: {
              featuresMasterData: {},
              isProductFetching: false,
              isProductFetchSuccess: false
            }
          });
        });
    };
  }

  /**
   * Method to get customer contract details
   */
  static getContractDetails() {
    return (dispatch, getState) => {
      dispatch({
        type: ActionConstants.SET_CONTRACTS_LOADING,
        payload: {
          isContractDataFetching: true,
          isContractDataSuccess: false,
        }
      });
      let soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      const modelNo = getState().configAPUData.payload.aircraftOEMs;
      let conData: any = [];
      let conDetails: any = [];
      // fetching contract details
      ConfigureAPUAPI.getContractDetails(soldTo, modelNo).
        then(response => {
          let contractdetails = response.data.contracts.distributions;
          contractdetails.map((contractdetail) => {
            let value = contractdetail.distributionNo;
            let text = value;
            let contractNo = value;
            let expiryDate = contractdetail.endDate;
            conData.push({ value, text });
            conDetails.push({ contractNo, expiryDate });
          });
          dispatch({
            type: ActionConstants.ADD_CONTRACT_DATA,
            payload: {
              conData,
              conDetails,
              isContractDataFetching: false,
              isContractDataSuccess: true,
            }
          });
        })
        .catch(error => {
          logError('Error fetching and parsing contract response', error);
          dispatch({
            type: ActionConstants.ADD_CONTRACT_DATA,
            payload: {
              conData: null,
              conDetails: null,
              isContractDataFetching: false,
              isContractDataSuccess: false,
            }
          });
        });
    };
  }

  /**
   * Onchange method for APU product terms checkbox in APU MSA serial number screen
   * @param acceptTermsStatus
   */
  static updateAcceptTermsStatus(acceptTermsStatus: boolean) {
    return (dispatch, getState) => {
      let acceptTermsErrorMsg = ''; // default error message
      const apuProductData = getState().configAPUData.payload;
      const validationFields = ['soldTo', 'contractNo', 'aircraftOem', 'serialNum'];
      const { hasErrors } = validateMsaInputData(apuProductData.msaConfigData, validationFields, [],getState);
      if (!acceptTermsStatus) {
        // terms accepted
        acceptTermsErrorMsg = CheckoutUILabels.APU_TERMS_ERROR_MSG;
      }
      dispatch({
        type: ActionConstants.UPDATE_APU_ACCEPT_TERMS_STATUS,
        payload: {
          acceptTermsStatus,
          acceptTermsErrorMsg,
          enableNextBtn: !hasErrors && acceptTermsStatus
        }
      });
    };
  }

  static checkExpiredContracts(userId: string) {
    return async (dispatch, getState) => {
      dispatch(
        // get cart products
        CartDetailsActions.getCartData(userId, 'selectedcart')
      );

      // let notifStatus: boolean = getState().configAPUData.payload.contractExpireNotif.notifStatus;
      let notifStatus: boolean = getState().configAPUData?.payload?.contractExpireNotif?.notifStatus ?? false;
      // notifStatus = notifStatus ?? false;
      if (!notifStatus) {
        await CartDetails.checkExpiredContracts(userId)
          .then(resp => {
            if (resp.status === CheckoutConstants.APU_ITEMS_DELETE_SUCCESS) {
              const notifUpdateObj: NotifUpdateI = {
                notifDisplayFlag: true,
                notifDisplayMsg: ApuErrorLabels.EXPIRED_CONTRACTS_DELETED_MSG,
                notifStatus: true,
              };
              dispatch(ConfigureAPUActions.updateExpiredContractsResponse(notifUpdateObj));

              dispatch(
                // get cart products & updates cart count
                CartDetailsActions.getCartData(userId, 'both')
              );

              dispatch(
                // updates order summary
                OrderSummaryActions.getOrderSummary(userId)
              );
            }
          }).catch(error => {
            logError('Invalid response from checkExpiredContracts ', error);
          });
      } else {
        const notifUpdateObj: NotifUpdateI = {
          notifDisplayFlag: false,
          notifDisplayMsg: '',
          notifStatus,
        };
        dispatch(ConfigureAPUActions.updateExpiredContractsResponse(notifUpdateObj));
      }
    };
  }

  static updateExpiredContractsResponse(response: NotifUpdateI) {
    return {
      type: ActionConstants.UPDATE_EXPIRED_CONTRACTS_RESPONSE,
      payload: response,
    };
  }

  static serialsIncart(configData) {
    const editProductSeq = configData.editCartAPUProductDetails.productSeq;
    const productsInCart = configData.productsInCart;
    const selectedProductID = configData.product.productId;
    let filteredApuCartProducts: Array<any> = [];

    if (editProductSeq) {
        // from cart page - ignoring validation for current cart line item
         productsInCart.map((product) => {
            if ( product.productId === selectedProductID  && product.productSeq !== editProductSeq){
              if (product.customerType.apuNonMsaSerials.length !== 0) {
                filteredApuCartProducts.push(...product.customerType.apuNonMsaSerials);
            }
            else if (product.customerType.apuMsaSerials.length !== 0) {
                filteredApuCartProducts.push(...product.customerType.apuMsaSerials);
            }
            }
        });
    } else {
        // from product listing page
         productsInCart.map((product) => {
            if (product.prodId === selectedProductID){
                if (product.customerType.apuNonMsaSerials.length !== 0) {
                    filteredApuCartProducts.push(...product.customerType.apuNonMsaSerials);
                }
                else if (product.customerType.apuMsaSerials.length !== 0) {
                    filteredApuCartProducts.push(...product.customerType.apuMsaSerials);
                }


            }
        });
    }

    const serialArrayofArray = filteredApuCartProducts.map((product) => {
        return product.serialNo;
    });
    let serialsInCart: any;
    serialsInCart = [].concat.apply([], serialArrayofArray);
    return serialsInCart;
  }
  static serviceOrdersIncart(configData) {
    const editProductSeq = configData.editCartAPUProductDetails.productSeq;
    const productsInCart = configData.productsInCart;
    const selectedProductID = configData.product.productId;

    let filteredNonMsaCartProducts: Array<any> = [];
    let serviceArrayofArray: any = [];

    if (editProductSeq) {
        // from cart page - ignoring validation for current cart line item
          productsInCart.map((product) => {
            if (product.prodId === selectedProductID && product.prodSeq !== editProductSeq) {
             const indexOfServiceOrder = product.customerType.apuNonMsaSerials.findIndex((x: any) => (x.subProductDesc === CheckoutConstants.NON_MSA_SERVICE_ORDER));
             if (indexOfServiceOrder !== -1) {
              filteredNonMsaCartProducts.push(product.customerType.apuNonMsaSerials[indexOfServiceOrder]);
             }
           }

       });
    } else {
        // from product listing page
         productsInCart.map((product) => {
             if (product.prodId === selectedProductID) {
              const indexOfServiceOrder = product.customerType.apuNonMsaSerials.findIndex((x: any) => (x.subProductDesc === CheckoutConstants.NON_MSA_SERVICE_ORDER));
              if (indexOfServiceOrder !== -1) {
                filteredNonMsaCartProducts.push(product.customerType.apuNonMsaSerials[indexOfServiceOrder]);
              }
            }

        });
    }
    if (typeof filteredNonMsaCartProducts !== 'undefined' && filteredNonMsaCartProducts.length !== 0){
     serviceArrayofArray = filteredNonMsaCartProducts.map((product) => {
        return product.distributionNo;
    });
  }
    let serviceOrdersInCart: any;
    serviceOrdersInCart = [].concat.apply([], serviceArrayofArray);
    return serviceOrdersInCart;
  }
  static hideAPUValidationErrorMsg(show: boolean) {
    return (dispatch) => {
      dispatch({
          type: ActionConstants.HIDE_VALIDATION_ERROR_MSG,
          payload: {
            showAPUValidationErrorMsg: show
          }
      });
    };
  }
  static getPurchaseOrderDetails() {
    return (dispatch, getState) => {
      dispatch({
        type: ActionConstants.SET_CONTRACTS_LOADING,
        payload: {
          isContractDataFetching: true,
          isContractDataSuccess: false,
        }
      });
      const soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      let purchaseOrders = [];
      let purchaseOrderDetails = [];

      ConfigureAPUAPI.getPurchaseOrderDetails(soldTo)
      .then(async (response) => {
          let data  = response.data.purchaseOrders.distributions;
          purchaseOrders = data.map((e: any) => ({ value: e.distributionNo, text: e.distributionNo }));
          await dispatch({
            type: ActionConstants.GET_PURCHASEORDER_DETAILS,
            payload: {
              purchaseOrders,
              purchaseOrderDetails: data,
              isContractDataFetching: false,
              isContractDataSuccess: true,
            }
          });
        }).catch(error => {
          logError('Error fetching and parsing contract response', error);
          dispatch({
            type: ActionConstants.GET_PURCHASEORDER_DETAILS,
            payload: {
              purchaseOrders,
              purchaseOrderDetails,
              isContractDataFetching: false,
              isContractDataSuccess: false,
            }
          });
      });
    };
  }

  static updatePurchaseOrderNo(distributionNo: string, index: number) {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      const poDetails = apuPayload.purchaseOrderDetails;
      let apuProductData = [...apuPayload.nonMsaConfigData];
      let purchaseType = apuPayload.featuresMasterData.filter((feature) => {
        if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_PURCHASE_ORDER) {
          return feature;
        }
      });
      let subProducts =  ConfigureAPUActions.getSubProductForSubProductId(purchaseType.length !== 0 ? purchaseType[0].subProductId : '', getState().configAPUData.payload.featuresMasterData);
      apuProductData[index].unitPrice = subProducts.length !== 0 ? subProducts[0].price : 0;
      apuProductData[index].subProductId = subProducts.length !== 0 ? subProducts[0].subProductId : '';
      apuProductData[index].subProductDesc = subProducts.length !== 0 ? subProducts[0].subProductDesc : '';
      apuProductData[index].purchaseOrderNumber = distributionNo;
      let countInCart = 0;
      let countAdded = 0;

      apuPayload.productsInCart.map((product) => {
        product.customerType.apuNonMsaSerials.map((po) => {
          if (po.distributionNo === distributionNo) {
            countInCart++;
          }
        });
      });

      apuProductData.forEach((po) => {
        if (po.purchaseOrderNumber === distributionNo) {
          countAdded++;
        }
      });

      let isQuantityValid = poDetails.map((po) => {
        if (po.distributionNo === distributionNo) {
          return !((countInCart + countAdded) > parseInt(po.remainingQuantity));
        } else {
          return false;
        }
      });

      poDetails.map((po, i) => {
        if (po.distributionNo === distributionNo) {
          apuProductData[index].expiryDate = po.endDate;
          apuProductData[index].validateQuantity = isQuantityValid[i];
        }
      });

      let totalPrice = ConfigureAPUActions.updateTotalPrice(apuProductData);
      let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
      const validationFields = ['soldTo', 'purchaseOrderNumber'];
      const { validatedData, hasErrors } = validateNonMsaInputData(apuProductData, validationFields, serialsIncart, getState);
      dispatch({
        type: ActionConstants.APU_UPDATE_CUSTOMER_PO_NONMSA,
        payload: {
          apuProductData: validatedData,
          enableNextBtn: !hasErrors,
          totalPrice: totalPrice
        }
      });
    };
  }
/* Methods for Non-MSA Service Order Configuration */
  static updateNonMsaSOSerial(serialNumber: string, index: number) {
    return (dispatch, getState) => {
      if (('' + serialNumber).length <= 8) {
        const apuPayload = getState().configAPUData.payload;
        let apuSOProductData = [...apuPayload.nonMsaServiceOrderConfigData];
        apuSOProductData[index].serialNumber = serialNumber;
        apuSOProductData[index].serialNumberError = '';
        let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
        const validationFields = ['aircraftOem', 'serialNum', 'cartDuplicateSl'];
        const { validatedData, hasErrors } = validateNonMsaInputData(apuSOProductData, validationFields, serialsIncart, getState);
        dispatch({
          type: ActionConstants.APU_UPDATE_NON_MSA_SO_SERIAL_NUMBER,
          payload: {
            apuSOProductData: validatedData,
            enableNextBtn: !hasErrors
          }
        });

      }
    };
  }

  static updateNonMsaSONumber(serviceOrderNumber: string, index: number) {
    return(dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      let purchaseType = apuPayload.featuresMasterData.filter((feature) => {
        if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_SERVICE_ORDER){
          return feature;
        }
      });
      let ServiceOrderConfigData = [...apuPayload.nonMsaServiceOrderConfigData];
      ServiceOrderConfigData[index].serviceOrderNumber = serviceOrderNumber;
      let serialsIncart: any = ConfigureAPUActions.serviceOrdersIncart(apuPayload);
      const validationFields = ['aircraftOem', 'serviceNum', 'cartDuplicateSO'];
      const { validatedData, hasErrors } = validateNonMsaInputData(ServiceOrderConfigData, validationFields, serialsIncart, getState);
      let subProducts =  ConfigureAPUActions.getSubProductForSubProductId(purchaseType.length !== 0 ? purchaseType[0].subProductId : '', getState().configAPUData.payload.featuresMasterData);
      validatedData[index].unitPrice = subProducts.length !== 0 ? subProducts[0].price : 0;
      validatedData[index].subProductId = subProducts.length !== 0 ? subProducts[0].subProductId : '';
      validatedData[index].subProductDesc = subProducts.length !== 0 ? subProducts[0].subProductDesc : '';
      let totalPrice = ConfigureAPUActions.updateTotalPrice(
        validatedData
      );

      dispatch({
        type: ActionConstants.APU_UPDATE_NON_MSA_SO_NUMBER,
        payload: {
          serviceOrderData: validatedData,
          totalPrice: totalPrice,
          enableNextBtn : !hasErrors
        }
      });
    };
  }
  static addNonMsaSORow() {
    return   (dispatch, getState) => {
    ValidateNonMSASOData(dispatch, getState, true);
    };
  }

  static deleteNonMsaSORow(selectedRows: []) {
    return(dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      const apuModel = apuPayload.aircraftOEMs;

      let previousRowData = apuPayload.nonMsaServiceOrderConfigData;
      if (previousRowData.length >= 1) {
        previousRowData = previousRowData.filter((obj) => {
            const indexFromSelectedRowData = selectedRows.findIndex((x: any) => (x.contractNo === obj.contractNo && x.aircraftOem === obj.aircraftOem && x.serialNumber === obj.serialNumber && x.soldTo === obj.soldTo));
            let returnFilterObj;
            if (indexFromSelectedRowData === -1) {
                returnFilterObj = obj;
            }
            return returnFilterObj;
        });
        let updatedProductData;
        let enableNextBtn;
        if (previousRowData.length !== 0){
        const validationFields = ['aircraftOem', 'serialNum', 'serviceNum', 'cartDuplicateSl'];
        const { validatedData, hasErrors } = validateNonMsaInputData(
              previousRowData,
              validationFields, [], getState
            );
        updatedProductData = [...validatedData];
        enableNextBtn = !hasErrors;
            }
            else {
              const newEmptyRow = {
                acOem: apuModel,
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                serviceOrderNumber: '',
                serviceOrderNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: '0.0',
                validInputData: false,
                subProductId: '',
                subProductDesc: ''
              };
              updatedProductData = [...previousRowData, newEmptyRow];
              enableNextBtn = false;
            }
        let totalPrice = ConfigureAPUActions.updateTotalPrice(
              updatedProductData
            );
        dispatch({
                  type: ActionConstants.APU_NONMSA_SO_DELETE_CONFIGURATION,
                  payload: {
                    updatedProductData: updatedProductData,
                    totalPrice: totalPrice,
                    enableNextBtn: enableNextBtn
              }
        });
      }
    };

  }

/* Methods for Non-MSA Key Only Order Configuration */
  static updateApuNonMsaKeyOnlySerialNumber(serialNumber: string, index: number) {
    return (dispatch, getState) => {
      if (('' + serialNumber).length <= 8) {
        const apuPayload = getState().configAPUData.payload;
        let purchaseType = apuPayload.featuresMasterData.filter((feature) => {
          // TODO Remove the following line after moving to QA
          if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_KEY_ONLY_ORDER) {
          // if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_KEY_ONLY_ORDER){
            return feature;
          }
        });
        let apukeyOnlyProductData = [...apuPayload.nonMsaKeyOnlyOrderConfigData];
        apukeyOnlyProductData[index].serialNumber = serialNumber;
        apukeyOnlyProductData[index].serialNumberError = '';
        let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
        const validationFields = ['aircraftOem', 'serialNum', 'cartDuplicateSl'];
        const { validatedData, hasErrors } = validateNonMsaInputData(apukeyOnlyProductData, validationFields, serialsIncart, getState);
        if (!hasErrors){
        let subProducts =  ConfigureAPUActions.getSubProductForSubProductId(purchaseType.length !== 0 ? purchaseType[0].subProductId : '', getState().configAPUData.payload.featuresMasterData);
        // validatedData[index].unitPrice = subProducts.length !== 0 ? subProducts[0].price : 0;
        validatedData[index].subProductId = subProducts.length !== 0 ? subProducts[0].subProductId : '';
        validatedData[index].subProductDesc = subProducts.length !== 0 ? subProducts[0].subProductDesc : '';
        }

        let totalPrice = ConfigureAPUActions.updateTotalPrice(
          validatedData
        );

        dispatch({
          type: ActionConstants.APU_NONMSA_KEY_ONLY_UPDATE_SERIAL_NUMBER,
          payload: {
            apuKeyOnlyProductData: validatedData,
            totalPrice: totalPrice,
            enableNextBtn: !hasErrors
          }
        });

      }
    };
  }


  static updateApuNonMsaKeyOnlySubscriptionPeriod(optionId: string, index: number) {
    return (dispatch, getState) => {
      // if (('' + serialNumber).length <= 8) {
        const apuPayload = getState().configAPUData.payload;
        let purchaseType = apuPayload.featuresMasterData.filter((feature) => {
          // TODO Remove the following line after moving to QA
          if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_KEY_ONLY_ORDER) {
          // if (feature.distributionType !== CheckoutConstants.CUSTOMER_CATEGORY_MSA && feature.subProductDesc === CheckoutConstants.NON_MSA_KEY_ONLY_ORDER){
            return feature;
          }
        });
        let apukeyOnlyProductData = [...apuPayload.nonMsaKeyOnlyOrderConfigData];
        apukeyOnlyProductData[index].optionError = '';
        apukeyOnlyProductData[index].optionId = optionId;
        const validationFields = ['aircraftOem', 'serialNum','subscriptionPeriod'];
        const { validatedData, hasErrors } = validateNonMsaInputData(apukeyOnlyProductData, validationFields,[], getState);
        let subProducts =  ConfigureAPUActions.getOptionValueForOptionId(optionId, purchaseType[0]?.options);
        apukeyOnlyProductData[index].unitPrice = subProducts.length !== 0 ? subProducts[0].price : 0;
        apukeyOnlyProductData[index].optionAvailable = purchaseType[0]?.optionsAvailable;
        apukeyOnlyProductData[index].term = subProducts.length !== 0 ? subProducts[0].term : '';
        apukeyOnlyProductData[index].optionName = subProducts.length !== 0 ? subProducts[0].optionName : '';

        let totalPrice = ConfigureAPUActions.updateTotalPrice(
          apukeyOnlyProductData
        );

        dispatch({
          type: ActionConstants.APU_NONMSA_KEY_ONLY_UPDATE_SERIAL_NUMBER,
          payload: {
            apuKeyOnlyProductData: apukeyOnlyProductData,
            totalPrice: totalPrice,
            enableNextBtn: !hasErrors
          }
        });

      // }
    };
  }

  static addApuNonMSAKeyOnlyRow() {
    return (dispatch, getState) => {
      const apuPayload = getState().configAPUData.payload;
      const previousRowData = apuPayload.nonMsaKeyOnlyOrderConfigData;
      const acOem = getState().configAPUData.payload.aircraftOEMs;

      let serialsIncart: any = ConfigureAPUActions.serialsIncart(apuPayload);
      const validationFields = ['aircraftOem', 'serialNum', 'paymentSel', 'cartDuplicateSl','subscriptionPeriod'];
      const { validatedData, hasErrors } = validateNonMsaInputData(previousRowData, validationFields, serialsIncart, getState);
      let updatedProductData;

      if (hasErrors) {
        updatedProductData = [...validatedData];
      } else {
        const purchaseType = previousRowData[0].paymentOption;
        // const price = previousRowData[0].unitPrice;
        const newEmptyRow = {
          acOem: acOem,
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: 0.00,
                validInputData: false,
                subProductId: '',
                optionId: '',
                optionError:'',
                optionAvailable: false,
                term: ''
        };
        updatedProductData = [...validatedData, newEmptyRow];
      }

      dispatch({
        type: ActionConstants.APU_NONMSA_KEY_ONLY_ADD_CONFIGURATION,
        payload: {
          updatedProductData,
          enableNextBtn: false
        }
      });
    };
  }

  static deleteApuNonMsaKeyOnlyRow(selectedRows: any) {
    return (dispatch, getState) => {
      let previousRowData = getState().configAPUData.payload.nonMsaKeyOnlyOrderConfigData;
      const apuModel = getState().configAPUData.payload.aircraftOEMs;
      let updatedProductData;
      let enableNextBtn;
      let totalPrice;

      if (previousRowData.length >= 1) {
        previousRowData = previousRowData.filter((obj) => {
        const indexFromSelectedRowData = selectedRows.findIndex((x: any) => (x.serialNumber === obj.serialNumber));
        let returnFilterObj;
        if (indexFromSelectedRowData === -1) {
            returnFilterObj = obj;
        }
        return returnFilterObj;
      });

        if (previousRowData.length !== 0) {
          const validationFields = ['aircraftOem', 'serialNum', 'paymentSel'];
          const { validatedData, hasErrors } = validateNonMsaInputData(
            previousRowData,
            validationFields, [], getState
          );

          updatedProductData = [...validatedData];
          enableNextBtn = !hasErrors;

          totalPrice = ConfigureAPUActions.updateTotalPrice(
            previousRowData
          );
        } else {
          const newEmptyRow = {
            acOem: apuModel,
            oemError: '',
            serialNumber: '',
            serialNumberError: '',
            paymentOption: '',
            paymentOptionError: '',
            unitPrice: 0,
            extendedPrice: '0.0',
            subProductId: '',
            validInputData: false,
            subProductDesc: ''
          };

          updatedProductData = [...previousRowData, newEmptyRow];
          totalPrice = ConfigureAPUActions.updateTotalPrice(previousRowData);
      }
    }
      dispatch({
        type: ActionConstants.APU_NONMSA_KEY_ONLY_DELETE_CONFIGURATION,
        payload: {
          updatedProductData: updatedProductData,
          totalPrice: totalPrice,
          enableNextBtn: enableNextBtn
        }
      });
    };
  }

}

export default ConfigureAPUActions;
